import { useParams } from "react-router-dom";
import FramebaseTemplate from "@/components/pages/MicroSite/Templates/FramebaseTemplate/FramebaseTemplate";
import FlowkitTemplate from "@/components/pages/MicroSite/Templates/FlowkitTemplate/FlowkitTemplate";
import SitecraftTemplate from "@/components/pages/MicroSite/Templates/SitecraftTemplate/SitecraftTemplate";
// import { ChevronLeft } from "lucide-react";
import {
  useProgramme
} from '@/lib/api/hooks/programme'
import LoadingSpinner from "@/components/ui/LoadingSpinner";

const MicrositeDetails = () => {
    const { programmeId } = useParams()
  
  const urlQueryParams = new URLSearchParams(window.location.search);
  const micrositeTemplate = urlQueryParams.get('template');
  const { data, isLoading } = useProgramme(programmeId)
  const templateData = data?.data?.microSite || null;

  const renderTemplate = (id: string | null) => {
    switch(id?.toLowerCase()){
      case 'framebase_template':
        return <FramebaseTemplate data={templateData} />;
      case 'sitecraft_template':
        return <SitecraftTemplate data={templateData} />;
      case 'flowkit_template':
        return <FlowkitTemplate data={templateData} />;
      default:
        return <div>Please select a template</div>;
    }
  }

  if(isLoading){
    return <div className="flex justify-center items-center h-screen">
      <LoadingSpinner />;
    </div> 
  };

  return (
    <div>
      {/* Heading */}
        {/* <div className="bg-black p-4 md:px-8 flex items-center justify-between sticky top-0 z-50">
                <div className="flex items-center gap-3">
                  <Link to="" className="flex items-center p-2 bg-[#333232] rounded cursor-pointer">
      
                    <ChevronLeft fill="white" />
      
                  </Link>
                 
                </div>
      
              </div> */}
              
      <div className="bg-white">{renderTemplate(micrositeTemplate)}</div>
    </div>
  )
}

export default MicrositeDetails